import { createAnnotation } from "@pages/Article/components/ArticleParagraphElements/annotation/AnnotationFactory";
import { ArticleNonParagraphProps } from "@pages/Article/components/ArticleParagraphElements/utils/types";
import { cn } from "@util/helpers";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

/**
 * Renders a numbered list element in an article.
 * This component processes the body string to extract list items and applies appropriate styles and classes.
 */
const ListNumbered = ({
  bodyString,
  className,
  paragraphWidth,
}: ArticleNonParagraphProps): React.ReactElement => {
  const transformAnnotation = createAnnotation({});

  const transformList = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type === "tag" && node.name === "ol") {
      const el = node;

      const children = el.children as DOMNode[];

      return (
        <ul
          className={cn(
            "mb-6 list-outside list-decimal",
            className,
            paragraphWidth,
            "[&>ul]:list-outside [&>ul]:list-decimal [&>ul]:pl-8",
            "pl-8 md:pl-8" // enure consistent padding across types
          )}
          data-testid="article-list-numbered-component"
        >
          {domToReact(children, {
            replace: (childNode: DOMNode) => {
              if (childNode.type === "tag" && childNode.name === "li") {
                const listItem = childNode;
                const listItemChildren = listItem.children as DOMNode[];

                return (
                  <li className="whitespace-pre-wrap text-xl">
                    {domToReact(listItemChildren, {
                      replace: transformAnnotation,
                    })}
                  </li>
                );
              }

              return childNode;
            },
          })}
        </ul>
      );
    }
  };

  return <>{parse(bodyString, { replace: transformList })}</>;
};

export default ListNumbered;
